import {AfterViewInit, Component, ElementRef, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserService} from '../../../user/user.service';
import {DbResponse} from "../../../shared/interceptors/db-response";
import {DbServerErrors} from "../../../shared/interceptors/db-server-errors";
import {TypeUtils} from "../../../shared/utils/type-utils";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {filter, first} from "rxjs/operators";


@Component({
    selector: 'db-enable-2fa',
    templateUrl: 'enable-2fa.component.html',
    styleUrls: ['enable-2fa.component.scss'],
    standalone: false
})
export class Enable2faComponent extends DialogComponent<null, boolean> implements OnInit, AfterViewInit {
  public loading: boolean;
  public userId?: any;
  public isCopiedCodes: boolean;
  public formSubmitted: boolean;
  public hasServerFieldErrors: boolean;
  public _2faCreated: boolean;
  public qrCodeImage: any;
  public _2faSecret: any;
  public _2faForm: FormGroup;
  public serverErrors: DbServerErrors;
  public recoveryCodes: any[];
  public recoveryCodesForCopy: string;

  constructor(
    private _userService: UserService,
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private elementRef: ElementRef
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.serverErrors = null;
    this.formSubmitted = false;
    this._2faForm = new FormGroup({
      _2faCode: new FormControl("", [Validators.required])
    });
    this._userService.getQrCode()
      .pipe(filter((response: DbResponse) => !!response),
      first())
      .subscribe((response: DbResponse) => {
        if (response.success) {
          localStorage.setItem('2faSetupSuccess', '1');
          this.qrCodeImage = response.data.qrcode;
          this._2faSecret = response.data.secret;
          this._store.dispatch(new fromStore.LoadUser);
        }
      });
  }
  ngAfterViewInit() {
    setTimeout( () => {
      const el = this.elementRef && this.elementRef.nativeElement.querySelector('._2fa-code');
      if (el) {
        el.focus();
      }
    }, 1000);
  }

  /* submit on enter key press */
  keyDownFunction(event) {
      if (event.keyCode === 13) {
        this.enable2fa();
      }
  }

  public enable2fa() {
    this.formSubmitted = true;
    if (this._2faForm.valid) {
      this.loading = true;
      this._userService.finish2faSetup(this._2faForm.value._2faCode)
        .pipe(filter((response: DbResponse) => !!response),
        first())
        .subscribe((response: DbResponse) => {
          if (response.success) {
            this._2faCreated = true;
            this.recoveryCodes = response.data.recovery_codes;
            this.recoveryCodesForCopy = response.data.recovery_codes.join("\n");
            this.result = true;
          }
          else {
            this.serverErrors = response.serverErrors;
          }
          this.hasServerFieldErrors = response.serverErrors && !TypeUtils.isEmpty(response.serverErrors.fields);

          this.loading = false;
        });
    }
  }

  public copiedCodes() {
    this.isCopiedCodes = true;
    setTimeout( () => this.isCopiedCodes = false, 800);
  }
}
